import { StyledSubTitleText } from './SubTitle.styles';

interface SubTitleTextProps {
    text: string;
}

export const SubTitleText = ({ text }: SubTitleTextProps) => {
    return <StyledSubTitleText>{text}</StyledSubTitleText>;
};
